import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { watch } from 'vue';
import { useStore } from 'vuex';
import { latestMessage, type WebSocketMessageWithFields, type WebSocketMessageEmpty } from '@/plugins/ws';

import {RootState} from "@/store";

type LanguagePageItemWithId = {
  idLanguagePageItem: number;
};

// Типы для WebSocket сообщений компонента languagePageItems
type LanguagePageItemsListMessage = WebSocketMessageWithFields<'language-page-item-list', {
  languagePageItems: unknown[];
}>;
type LanguagePageItemCreateMessage = WebSocketMessageWithFields<'language-page-item-create' | 'language-page-item-create-success', LanguagePageItemWithId & {
  idLanguagePage: number;
  code: string;
}>;
type LanguagePageItemDeleteMessage = WebSocketMessageWithFields<'language-page-item-delete' | 'language-page-item-delete-success', LanguagePageItemWithId>;
type LanguagePageItemListTranslationsMessage = WebSocketMessageWithFields<'language-page-item-list-translations', {
  languagePageItem: unknown;
}>;

// Объединенный тип для всех сообщений
type LanguagePageItemsWebSocketMessage = 
  | LanguagePageItemsListMessage 
  | LanguagePageItemCreateMessage 
  | LanguagePageItemDeleteMessage 
  | LanguagePageItemListTranslationsMessage;

// WebSocket message handler

export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'dataLanguagePageItems',
},
  __name: 'languagePageItems',
  setup(__props) {

const store = useStore<RootState>();



// Базовый тип для сообщений с ID элемента языковой страницы
const handleWebSocketMessage = (data: LanguagePageItemsWebSocketMessage): void => {
  if (!data?.signal) return;

  switch (data.signal) {
    case 'language-page-item-list':
      store.dispatch('languagePageItems/wsSetLanguagePageItems', { languagePageItems: data.languagePageItems });
      break;

    case 'language-page-item-create':
    case 'language-page-item-create-success':
      store.dispatch('languagePageItems/wsLanguagePageItemCreate', {
        idLanguagePageItem: data.idLanguagePageItem,
        idLanguagePage: data.idLanguagePage,
        code: data.code,
      });
      break;

    case 'language-page-item-delete':
    case 'language-page-item-delete-success':
      store.dispatch('languagePageItems/wsLanguagePageItemDelete', { idLanguagePageItem: data.idLanguagePageItem });
      break;

    case 'language-page-item-list-translations':
      store.dispatch('languagePageItem/wsSetLanguagePageItem', data.languagePageItem);
      break;
  }
};

watch(latestMessage, handleWebSocketMessage);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div"))
}
}

})